import React, { useRef, useEffect, useState } from 'react'
import * as settings from '../settings.js'

import './styles.scss';

const Circle = ({party}: {party: string}) => 
{
  if(party === 'vacant')
  {
    return (
      <span
        className={`circle`}
        aria-label={party}
        style={{
          backgroundColor: '#fff',
          border: "1px dotted black"
        }}>
      </span>
    )
  }

  return (
    <span 
      className={`circle`}
      aria-label={party}
      style={{backgroundColor: settings.partyColor[party]}}>
    </span>
  )
}

export const PartyCircles = ({ 
  data,
}: {
  data: Array<string>,
}) => {
  return (
    <div className='partycircles'>
        {data.map((e, i) => <Circle key={i} party={e} />)}
    </div>
  )
}
